module.exports = "../../app/cells/components/modals/configure_account/finish_to_ils_experiment_cell.rb";